// extracted by mini-css-extract-plugin
export default {"ShopItemPagePurchaseControlsNormal":"ShopItemPagePurchaseControls_ShopItemPagePurchaseControlsNormal__zAHlD"};